/**
 * SearchText
 */
export default class SearchText {
    rootPath = '';
    isLoading = false;
    form =null;
    type = null;
    searchQuery = '';
    currentQuery = ''; // Used to compare the text length to any new query.
    resultsCount = 0;
    resultsCountPanelDocked = false;
    tripLayerInitialized = false;
    constructor(root, type, searchQuery, resultsCount) {
        this.rootPath = root;
        this.type = type;
        this.searchQuery = searchQuery;
        this.resultsCount = resultsCount;
    }
    init() {
        this.form = document.getElementById('search-text-form');
        this.loadMapLocations();
        this.togglePagination();
        this.observeButtonVisibility();
        this.loadResultsCount();
        this.setResultsCountPanelDocked();
        if (window.addEventListener) {
            window.addEventListener('popstate', () => {
                if (window.history.state === null) {
                    location.reload();
                } else {
                    window.location = window.history.state.path + '&ajax_reload=true';
                }
            });
        }

        const updateMapTypeEvent = new CustomEvent('update-map-type', {
            detail: {
                type: this.type,
            },
        });
        window.dispatchEvent(updateMapTypeEvent);
        if (this.type === 'trip') {
            setTimeout(() => {
                this.updateVisibleMarkers();
            }, 1000);
        }

    }

    loadResultsCount() {
        try {
            this.resultsCount = JSON.parse(this.$refs.resultsCountPanel.dataset.resultsCount);
        } catch (error) {
            console.error('Error in SearchSentence init', error);
            this.resultsCount = 0;
        }
    }

    loadMapLocations() {
        const locations = Array.from(document.querySelectorAll('.SearchSentenceCard')).filter(card => card?.dataset?.lng && card?.dataset?.lat).map(card => {
            return {
                id: card.dataset.id,
                coordinates: [
                    card.dataset.lng,
                    card.dataset.lat,
                ],
                type: card.dataset.type,
            };
        });

        const updateMapLocationsEvent = new CustomEvent('update-map-locations', {
            detail: {
                locations
            }
        });

        window.dispatchEvent(updateMapLocationsEvent);

        // this.$dispatch('update-map-locations', {
        //     locations,
        //     type: this.type,
        // });
    }

    /**
     * Selector methods
     */
    selectType(type) {
        this.type = type;
        this.form.querySelector('input[name="filter-page"]').value = 1;
        this.form.querySelector('input[name="filter-type"]').value = type;
        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData).toString();
        // set page to 1

        const url = new URL(window.location.href);
        // // navigate to the new url
        if(this.searchQuery.length >= 3) {
            console.log('searchQuery', this.searchQuery);
            this.fetchContent(url.pathname + '?' + searchParams);
            //  window.location.href = url.pathname + '?' + searchParams;
        }
    }

    filterText(e) {
        if(this.isLoading) {
            return;
        }

        if(this.searchQuery.length >= 3) {
            this.handleSubmit(e);
        } else if(this.currentQuery.length >= 3 && this.searchQuery.length < 3) {
            this.handleSubmit(e, false, true);
        }

        this.currentQuery = this.searchQuery;
    }


    /**
     * Form submission. Currently triggered by selecting a dropdown option
     * @param e
     * @param append
     */
    handleSubmit(e, append = false, clear = false) {
        if (e) {
            e.preventDefault();
        }
        if (!append) {
            this.form.querySelector('input[name="filter-page"]').value = 1;
        }
        const formData = new FormData(this.form);
        const searchParams = clear ? '' : new URLSearchParams(formData).toString();
        const url = new URL(window.location.href);

        if (!append) {
            this.fetchContent(url.pathname + '?' + searchParams);
        } else {
            this.fetchMoreContent(url.pathname + '?' + searchParams);
        }
    };

    /**
     * Observe the visibility of the pagination button
     */
    observeButtonVisibility() {
        const paginationContainer = document.querySelector('.ElasticFilter__Pagination');
        if (!paginationContainer) {
            return;
        }
        const interval = 200; // Interval in milliseconds for periodic checks
        const checkVisibility = () => {
            if (!this.isContainerVisible(paginationContainer)) {
                return; // Do nothing if the container is not visible
            }
            const button = paginationContainer.querySelector('button');
            if (button && this.isButtonVisible(button, 500) && !this.isLoading) {
                this.loadMore();
            }
        };

        this.visibilityCheckInterval = setInterval(checkVisibility, interval);
    }

    /**
     * Check if the container is visible
     * @param container
     * @returns {boolean}
     */
    isContainerVisible(container) {
        const style = getComputedStyle(container);
        return style.display !== 'none'; // Check if the container is visible
    }

    /**
     * Check if the button is visible
     * @param button
     * @returns {boolean}
     */
    isButtonVisible(button, offset = 0) {
        const rect = button.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        // Check if the button is in the viewport
        return (rect.top - offset) <= windowHeight && rect.bottom >= 0;
    }

    /**
     * Cleanup method if the component is destroyed. As we normally recall the page, it's not needed.
     * Call this method if no more page reloads are expected.
     */
    cleanup() {
        // Clear the interval when the component is destroyed
        if (this.visibilityCheckInterval) {
            clearInterval(this.visibilityCheckInterval);
        }
    }

    /**
     * Load more results
     */
    loadMore(e) {
        if (e) {
            e.preventDefault();
        }

        if ((parseInt(this.form.querySelector('input[name="filter-page"]').value) * parseInt(this.form.querySelector('input[name="filter-page_size"]').value)) > parseInt(this.form.querySelector('input[name="total"]').value)) {
            return;
        }
        this.form.querySelector('input[name="filter-page"]').value = parseInt(this.form.querySelector('input[name="filter-page"]').value) + 1;
        // Check if total resutls are reached
        this.handleSubmit(e, true)
    }

    /**
     * Ajax fetch content
     * @param url
     */
    fetchContent(url) {
        const elements= ['data-pegasus-filterable="results"', 'data-pegasus-filterable="filters"'];
        
        //show LoadingScreen
        this.isLoading = true;
        const historyUrl = url;

        pegasus.ajaxContent(url, elements, {}, () => {
            this.form = document.getElementById('search-text-form');
            this.loadResultsCount();
            this.togglePagination();
            this.observeButtonVisibility();
            if (this.type === 'trip'){
                this.resetMapLocations();
                this.updateVisibleMarkers();
            } else {
                this.loadMapLocations();
            }
            this.pushToHistory(document.title, historyUrl);
            this.isLoading = false;
        });
    }

    /**
     * Fetch the content and append it
     * @param url
     */
    fetchMoreContent(url) {
        const elements = ['data-pegasus-filterable="results"'];
        this.isLoading = true;
        const historyUrl = url;
        pegasus.ajaxFetchAndAppendContent(url, elements, {}, () => {
            this.loadResultsCount();
            this.togglePagination();
            this.observeButtonVisibility();
            this.loadMapLocations();
            this.pushToHistory(document.title, historyUrl);
            this.isLoading = false;
        });
    }

    /**
     * Toggle the visibility of the pagination button
     */
    togglePagination() {
        const p = document.querySelector('.ElasticFilter__Pagination');
        if (!p) return;
        if ((parseInt(this.form.querySelector('input[name="filter-page"]').value) * parseInt(this.form.querySelector('input[name="filter-page_size"]').value)) < parseInt(this.form.querySelector('input[name="total"]').value)) {
            p.style.display = 'block';
        } else {
            p.style.display = 'none';
        }
    }

    /**
     * Check if the browser supports history
     * @returns {boolean}
     */
    historySupported() {
        return !!(window.history && history.pushState);
    }

    /**
     * pushing a title and an url into the history
     * @param title
     * @param url
     */
    pushToHistory(title, url) {
        if (this.historySupported()) {
            history.pushState({ path: url }, title, url);
            pegasus.setCookie('lastExplorePage', window.location.href, 1);
        }
    }

    /**
     * Checks if the results count panel is docked 
     */
    setResultsCountPanelDocked() {
        this.resultsCountPanelDocked = this.$refs.resultsCountPanel.getBoundingClientRect().top <= (this.$refs.navPanel.clientHeight + 3);
    }

    /**
     * Scroll to top of screen 
     */
    goToTop(e) {
        e.preventDefault();

        window.scrollTo({
            top: 0, 
            left: 0,
            behavior: 'smooth',
        });
    }

    goToLastPage() {
        if (pegasus.getCookie('lastPage')) {
            window.location.href = pegasus.getCookie('lastPage');
        } else {
            window.location.href = '/';
        }

    }

    updateVisibleMarkers() {
        // Get all result elements
        if (this.type !== 'trip') {
            return;
        }
        let visibleCoordinates = [];
        // Check each result to see if it's in the viewport
        const result = this.getElementWithLargestVisibleArea(document.querySelectorAll('.Trip_Result'));
        if (result) {
            const coordinates = JSON.parse(result.getAttribute('data-coordinates'));
            visibleCoordinates = visibleCoordinates.concat(coordinates);
        }
        if (visibleCoordinates.length === 0 && document.querySelectorAll('.Trip_Result').length > 0 && !this.tripLayerInitialized) {
            // If no results are in the viewport, use the first result
            const coordinates = JSON.parse(document.querySelectorAll('.Trip_Result')[0].getAttribute('data-coordinates'));
            visibleCoordinates = visibleCoordinates.concat(coordinates);
            this.tripLayerInitialized = true
        }

        // Update map with visible coordinates
        if (visibleCoordinates.length > 0) {
            this.resetMapLocations();
            console.log('Updating map with visible coordinates', visibleCoordinates);
            const updateMapLocationsEvent = new CustomEvent('update-map-locations', {
                detail: {
                    locations: visibleCoordinates,
                    type: this.type,
                },
            });

            window.dispatchEvent(updateMapLocationsEvent);
        }
    }

    getElementWithLargestVisibleArea(els) {
        let maxVisibleArea = 0;
        let elementWithMaxArea = null;

        els.forEach(el => {
            const rect = el.getBoundingClientRect();
            const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

            const visibleWidth = Math.max(0, Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0));
            const visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
            const visibleArea = visibleWidth * visibleHeight;

            if (visibleArea > maxVisibleArea) {
                maxVisibleArea = visibleArea;
                elementWithMaxArea = el;
            }
        });

        return elementWithMaxArea;
    }

    resetMapLocations() {
        const resetMapLocationsEvent = new CustomEvent('update-map-locations', {
            detail: {
                locations: [],
                type: this.type,
            },
        });
        window.dispatchEvent(resetMapLocationsEvent);
    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('searchText', (root, type, searchQuery, resultsCount) => new SearchText(root, type, searchQuery, resultsCount));
});
